import { useEffect } from "react";

import { useDispatch } from "react-redux";

import { showSuccessToast } from "app/actions/toast_actions";
import { isAvailable } from "app/common/services/pageClaims";
import { swSettings } from "app/common/services/swSettings";
import { ADDON_HISTORICAL_DATA_FROM_QUERY } from "app/common/services/swSettingsUtils";
import { translate } from "app/filters/i18nFilter";
import { getQueryParam, removeQueryFromUrl } from "app/UtilitiesAndConstants/UtilityFunctions/queryUtils";

export const toastForAddOnBuyers = () => {
    const dispatch = useDispatch();

    const showToast = () => {
        const addonParam = getQueryParam(ADDON_HISTORICAL_DATA_FROM_QUERY);
        dispatch(
            showSuccessToast(
                translate("historical.data.addon.success.toast.text", {
                    count: addonParam,
                }),
            ),
        );
    };

    useEffect(() => {
        //check if the user can see the addon's and as addon on query params
        if (
            isAvailable(swSettings.components.AllowHistoricalDataAddon) &&
            window.location.search.includes(ADDON_HISTORICAL_DATA_FROM_QUERY)
        ) {
            showToast();
            removeQueryFromUrl(ADDON_HISTORICAL_DATA_FROM_QUERY);
        }
    }, []);
};
